import React from 'react';
import AllSavingPlans from './components/TableData';
const index = () => {
  return (
    <div>
      <AllSavingPlans />
    </div>
  );
};

export default index;
